import styled from 'styled-components';
import { RouterLink } from '@redux-first-router-link';

import {
  Button,
  buttonCSS,
  DeprecatedGrid as Grid,
} from '@simplywallst/ui-core';

import type { ButtonProps } from '@simplywallst/ui-core';

export const ViewNarrativeLink = styled(RouterLink)<ButtonProps>`
  ${buttonCSS}
  align-items: center;
  display: inline-flex;
  justify-content: center;
`;

export const NarrativeWrapper = styled(Grid)`
  background: ${({ theme }) => theme.color.phantom};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  height: 100%;
  overflow: hidden;
  width: 100%;
`;

export const HeadingLinkWrapper = styled(RouterLink)`
  display: grid;
  grid-gap: ${({ theme }) => theme.x2spacePx}px;
  text-decoration: none;
`;

export const ValuationHistogramLinkWrapper = styled(RouterLink)`
  text-decoration: none;
`;

export const ValuationHistogramWrapper = styled(Grid)`
  background: ${({ theme }) => theme.color.spaceGray};
  padding: ${({ theme }) => theme.x3spacePx}px;
`;

export const GridWrapper = styled(Grid)`
  background: ${({ theme }) => theme.color.phantom};
  padding: ${({ theme }) => theme.x2spacePx}px;
`;

export const AuthorImage = styled.img`
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.color.white};
  height: ${({ theme }) => theme.x4spacePx}px;
  object-fit: cover;
  vertical-align: middle;
  width: ${({ theme }) => theme.x4spacePx}px;
`;

export const StyledButton = styled(Button)`
  padding: 0;
  text-align: left;

  &:hover {
    text-decoration: underline;
  }
`;
